export default __webpack_public_path__ + "static/media/bar-chart.e7a95964.svg";